<a routerLink="/{{ this.params.url }}" [queryParams]="this.params.queryParams" target="_blank">{{ this.params.text }}</a>
